import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { buildConfigurationValidationSchema } from 'src/pages/ConfigurationPage/utils/buildConfigurationValidationSchema';

// Owns the persona/system-prompt react-hook-form instance: initial values
// sourced from the active version's input data, and a validation schema that
// stays in sync with the active version's required-field configuration.
export const useConfigurationForm = ({
  inputData,
  formFieldsObject,
  systemPromptActive,
}: {
  inputData: any;
  formFieldsObject: Record<string, any>;
  systemPromptActive: boolean;
}) => {
  return useForm<any>({
    defaultValues: {
      pf_ai_name: inputData?.pf_ai_name || '',
      pf_company_name: inputData?.pf_company_name || '',
      pf_company_description: inputData?.pf_company_description || '',
      pf_pages: inputData?.pf_pages || [],
      pf_role: inputData?.pf_role || formFieldsObject?.pf_role?.default_value?.value || 'support',
      pf_tone_of_voice_channel:
        inputData?.pf_tone_of_voice_channel ||
        formFieldsObject?.pf_tone_of_voice_channel?.default_value?.value ||
        'chat',
      pf_tone_of_voice_style:
        inputData?.pf_tone_of_voice_style ||
        formFieldsObject?.pf_tone_of_voice_style?.default_value?.value ||
        'casual',
      pf_tone_of_voice_style_custom: inputData?.pf_tone_of_voice_style_custom || '',
      pf_role_custom: inputData?.pf_role_custom || '',
      pf_tone_of_voice_emoji:
        typeof inputData?.pf_tone_of_voice_emoji === 'boolean'
          ? inputData?.pf_tone_of_voice_emoji
          : false,
      pf_tone_of_voice_resp_len:
        inputData?.pf_tone_of_voice_resp_len ||
        formFieldsObject?.pf_tone_of_voice_resp_len?.default_value?.value ||
        'concise',
      pf_default_language:
        inputData?.pf_default_language ||
        formFieldsObject?.pf_default_language?.default_value ||
        {},
      pf_excluded_languages: inputData?.pf_excluded_languages || [],
      pf_words_blacklist: inputData?.pf_words_blacklist || [],
      pf_custom_workflows: inputData?.pf_custom_workflows || [],
      pf_default_workflow: inputData?.pf_default_workflow || {},
      text: '',
    },
    resolver: yupResolver<any, any, any>(
      buildConfigurationValidationSchema(formFieldsObject, systemPromptActive),
    ),
  });
};
